import { methodResult, post } from "./api.js";
import { config, labels } from "./config.js";
import { setBusy, showFieldError, showNotice, showView, validateEmail } from "./components.js";
import { storeEmailHandoff } from "./email-handoff.js";

export function initSignup() {
	const emailForm = document.querySelector("[data-auth-signup-email-form]");
	const detailsForm = document.querySelector("[data-auth-signup-details-form]");
	if (!emailForm || !detailsForm) return;
	const email = emailForm.elements.email;
	const firstName = detailsForm.elements.first_name;
	const lastName = detailsForm.elements.last_name;
	const password = detailsForm.elements.password;
	const storedEmail = detailsForm.querySelector("[data-auth-signup-email-value]");
	const existingGoogleLogin = emailForm.querySelector("[data-auth-existing-google-login]");
	const emailSubmit = emailForm.querySelector("[data-auth-submit]");
	let existingPasswordEmail = "";

	document.querySelector("[data-auth-show-signup-email]")?.addEventListener("click", () => {
		showView("signup-email");
		email.focus();
	});
	document.querySelector("[data-auth-back-to-signup]")?.addEventListener("click", () => {
		showView("signup-options");
	});
	document.querySelector("[data-auth-back-to-signup-email]")?.addEventListener("click", () => {
		showView("signup-email");
		email.focus();
	});
	email.addEventListener("input", () => {
		existingPasswordEmail = "";
		if (emailSubmit) emailSubmit.hidden = false;
		if (existingGoogleLogin) existingGoogleLogin.hidden = true;
		showNotice(emailForm, "");
	});

	emailForm.addEventListener("submit", async (event) => {
		event.preventDefault();
		showNotice(emailForm, "");
		const emailError = validateEmail(email);
		if (emailError) {
			showFieldError(email, emailError);
			return;
		}
		const candidate = email.value.trim().toLowerCase();
		if (existingPasswordEmail === candidate) {
			storeEmailHandoff(candidate);
			location.assign(config.routes?.login || "/login");
			return;
		}
		setBusy(emailForm, true, labels.checkingEmail);
		try {
			const payload = await post(
				"/api/method/syscofy_core.api.web_auth_registration.resolve_email_registration",
				{ email: email.value.trim() },
			);
			const result = methodResult(payload);
			if (!result?.ok) {
				showNotice(emailForm, result?.error?.message || labels.requestFailed);
				return;
			}
			if (result.status === "available" && result.can_register) {
				storedEmail.value = result.email;
				showView("signup-details");
				firstName.focus();
				return;
			}
			if (result.auth_method === "google" && existingGoogleLogin) {
				showNotice(emailForm, result.message, "success");
				if (emailSubmit) emailSubmit.hidden = true;
				existingGoogleLogin.hidden = false;
				return;
			}
			if (result.status === "existing_user") {
				existingPasswordEmail = candidate;
			}
			showNotice(emailForm, result.message || labels.requestFailed);
		} catch (error) {
			showNotice(
				emailForm,
				error.status === 429 ? labels.tooManyRequests : labels.requestFailed,
			);
		} finally {
			setBusy(emailForm, false, labels.checkingEmail);
		}
	});

	detailsForm.addEventListener("submit", async (event) => {
		event.preventDefault();
		showNotice(detailsForm, "");
		if (!firstName.value.trim()) return showFieldError(firstName, labels.firstNameRequired);
		if (!lastName.value.trim()) return showFieldError(lastName, labels.lastNameRequired);
		if (!password.value) return showFieldError(password, labels.passwordRequired);
		if (password.value.length < config.passwordPolicy.minimum_length) {
			return showFieldError(password, labels.passwordTooShort);
		}
		setBusy(detailsForm, true, labels.createAccount);
		try {
			const payload = await post(
				"/api/method/syscofy_core.api.web_auth_registration.register_with_email",
				{
					email: storedEmail.value,
					first_name: firstName.value.trim(),
					last_name: lastName.value.trim(),
					password: password.value,
				},
			);
			const result = methodResult(payload);
			if (!result?.ok) {
				const fields = { first_name: firstName, last_name: lastName, password };
				Object.entries(result?.field_errors || {}).forEach(([name, message]) => {
					if (fields[name]) showFieldError(fields[name], message);
				});
				showNotice(detailsForm, result?.error?.message || labels.requestFailed);
				return;
			}
			showNotice(detailsForm, result.message, "success");
			const button = detailsForm.querySelector("[data-auth-submit]");
			button.textContent = labels.requestSubmitted;
			button.disabled = true;
		} catch (error) {
			showNotice(
				detailsForm,
				error.status === 429 ? labels.tooManyRequests : labels.requestFailed,
			);
		} finally {
			const button = detailsForm.querySelector("[data-auth-submit]");
			if (button.textContent !== labels.requestSubmitted)
				setBusy(detailsForm, false, labels.createAccount);
		}
	});
}
